import { render } from "./Representantes.vue?vue&type=template&id=1c45bc02&scoped=true"
import script from "./Representantes.vue?vue&type=script&lang=js"
export * from "./Representantes.vue?vue&type=script&lang=js"

import "./Representantes.vue?vue&type=style&index=0&id=1c45bc02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c45bc02"]])

export default __exports__